import React, { FC, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { TextBox } from 'devextreme-react';

import { useRoleCopyMutation } from 'bus/role/services';
import { RoleCopy } from 'bus/role/types';

type Props = {
  roleId: number;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  onRefresh: () => void;
};

const initialForm: RoleCopy = {
  id: null,
  name: '',
};

const CloneRole: FC<Props> = ({ changeVisible, onRefresh, visible, roleId }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<RoleCopy>(initialForm);

  const onHidden = () => {
    createGroupValidationRef.current?.instance.reset();
    setForm(initialForm);
  };

  const [roleCopyMutation, { isLoading }] = useRoleCopyMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      await roleCopyMutation({ ...form, id: roleId });
      changeVisible(false);
      onRefresh();
    }
  };

  const handleHideModal = () => {
    changeVisible(false);
  };

  return (
    <Popup
      visible={visible}
      onHiding={handleHideModal}
      dragEnabled={true}
      closeOnOutsideClick={false}
      showTitle={true}
      title="Копировать роль"
      width={400}
      onHidden={onHidden}
      height="auto"
    >
      <div className="modal-block">
        <div className="modal-block__content">
          <form onSubmit={handleSubmit}>
            <ValidationGroup ref={createGroupValidationRef}>
              <Form formData={form}>
                <Item colSpan={12} colCount={12} itemType="group">
                  <AppRow>
                    <AppGroup col={12}>
                      <AppFiledBox label="Новое наименование" labelTop>
                        <TextBox
                          stylingMode="underlined"
                          placeholder="Наименование"
                          mode="text"
                          value={form.name}
                          onValueChange={(e: any) => {
                            setForm((prev) => ({ ...prev, name: e }));
                          }}
                        >
                          <Validator>
                            <RequiredRule message="Заполните поле Наименование" />
                          </Validator>
                        </TextBox>
                      </AppFiledBox>
                    </AppGroup>
                  </AppRow>
                </Item>
              </Form>
              <ModalFooter
                useSubmitBehavior={false}
                handleSubmit={handleSubmit}
                hideModal={handleHideModal}
                disabledSubmit={isLoading}
              />
            </ValidationGroup>
          </form>
        </div>
      </div>
    </Popup>
  );
};

export default CloneRole;
